import axios from "../axios-auth";
import orginal_axios from "axios";

export const machineService = {
  getMachineList,
  saveMachine,
  getMachineDetail,
  getMachineExcelExport,
  getMachinesByStatus,
  getMachineChecklistDetailsByMachineIds,
  getMaintenanceFrequenciesByMachineIds,
  getCheckListFrequenciesByMachineIds,
  getMachineExcelTemplate,
  saveMachineExcel
};

function getMachineList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }
  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.machineTypeId) {
    params["machineTypeId"] = searchParams.machineTypeId;
  }
  if (searchParams.codeOrName) {
    params["codeOrName"] = searchParams.codeOrName;
  }
  if (searchParams.model) {
    params["model"] = searchParams.model;
  }
  if (searchParams.countryId) {
    params["countryId"] = searchParams.countryId;
  }
  if (searchParams.installationData) {
    params["installationData"] = searchParams.installationData;
  }
  if (searchParams.maintenanceTypeId) {
    params["maintenanceTypeId"] = searchParams.maintenanceTypeId;
  }
  if (searchParams.maintenanceFrequencyId) {
    params["maintenanceFrequencyId"] = searchParams.maintenanceFrequencyId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (typeof searchParams.isAddDetails === "boolean") {
    params["isAddDetails"] = searchParams.isAddDetails;
  }

  return axios.get("/auth/machines", { params });
}

function saveMachine(machine) {
  if (!machine.id) {
    // new
    return axios.post("/auth/machine", machine);
  } else {
    // edit
    return axios.put("/auth/machine", machine);
  }
}

function getMachineDetail(id) {
  return axios.get("/auth/machine/" + id);
}

function getMachinesByStatus(status) {
  return axios.get("auth/machines-by-status/" + status);
}

function getMachineChecklistDetailsByMachineIds(searchParams) {
  let params = {};

  if (searchParams.machineIds) {
    params["machineIds"] = searchParams.machineIds.join();
  }

  return axios.get("/auth/machine-checklist-details-by-machineIds", { params });
}

function getMaintenanceFrequenciesByMachineIds(searchParams) {
  let params = {};

  if (searchParams.machineIds) {
    params["machineIds"] = searchParams.machineIds.join();
  }

  if (searchParams.machineCheckListDetailIds) {
    params["machineCheckListDetailIds"] =
      searchParams.machineCheckListDetailIds.join();
  }

  return axios.get("/auth/maintenance-frequencies-by-machineIds", { params });
}

function getCheckListFrequenciesByMachineIds(searchParams) {
  let params = {};

  if (searchParams.machineIds) {
    params["machineIds"] = searchParams.machineIds.join();
  }

  if (searchParams.machineCheckListDetailIds) {
    params["machineCheckListDetailIds"] =
      searchParams.machineCheckListDetailIds.join();
  }

  return axios.get("/auth/checklist-frequencies-by-machineIds", { params });
}

function getMachineExcelExport(searchParams) {
  let params = {};
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.machineTypeId) {
    params["machineTypeId"] = searchParams.machineTypeId;
  }
  if (searchParams.codeOrName) {
    params["codeOrName"] = searchParams.codeOrName;
  }
  if (searchParams.model) {
    params["model"] = searchParams.model;
  }
  if (searchParams.countryId) {
    params["countryId"] = searchParams.countryId;
  }
  if (searchParams.installationData) {
    params["installationData"] = searchParams.installationData;
  }
  if (searchParams.maintenanceTypeId) {
    params["maintenanceTypeId"] = searchParams.maintenanceTypeId;
  }
  if (searchParams.maintenanceFrequencyId) {
    params["maintenanceFrequencyId"] = searchParams.maintenanceFrequencyId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (typeof searchParams.isAddDetails === "boolean") {
    params["isAddDetails"] = searchParams.isAddDetails;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/export-machine-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function (response) {
    return {
      blob: new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}

function getMachineExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/machine-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function (response) {
    return {
      blob: new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}

function saveMachineExcel(file) {
  return axios.post("/auth/machine-excel", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
